export function kliknalMenuGorne() {
    document.addEventListener(
        'click',
        function (event) {
            const target = event.target.closest('[data-ga-event-kliknal-menu-gorne]');
            if (!target) return;

            window.dataLayer = window.dataLayer || [];

            const getText = (...elements) => {
                for (const el of elements) {
                    if (!el) continue;
                    const text = el.textContent?.trim();
                    if (text) return text;
                }
                return '';
            };

            const title = getText(
                target,
                target.querySelector('.navigation__text'),
                target.querySelector('span')
            );

            const url = target.getAttribute('href') || '';

            window.dataLayer.push({
                event: 'kliknal_menu_gorne',
                title,
                clicked_url: url,
                page_url: window.location.href,
            });
        },
        true // 👈 FAZA CAPTURE
    );
}
